<template>
  <!-- @click="toggleChoice" -->
  <div
    :style="fixedHeight"
    :class="{
      'current-user-notification-parent': isCurrentUser && !mobileView,
      'fixed-height': !submitMode && !mobileView,
      pointer: mobileView && value > 0,
    }"
    class="k-choice-value"
  >
    <div class="test w-100 text-left">
      <div
        v-if="loading == 1"
        :style="style"
        class="text-white text-size-12 bg-submitted loading-field"
        role="status"
        v-html="$t('choiceDialog.answerSubmitted')"
      ></div>
      <div class="d-flex justify-content-center align-items-end text-size-22" :style="style" v-if="value === -1">
        <div
          v-if="isLimitReached"
          class="items-aligned-center text-size-12"
          :class="{ 'text-size-10': !isDesktopMode }"
        >
          {{ $t('choiceDialog.notAvailable') }}
        </div>
        <template v-else>
          <div
            class="text-size-12 align-items-center submit-row-bg empty-cell-value"
            v-if="showEditButton"
          >
            <BtnLink
              :label="$t('general.selectAnswer')"
              :labelCustomClass="'font-size-10'"
            />
          </div>
        </template>
      </div>
      <RenderNameOfQuestion
        v-if="showNameOfQuestion"
        :isLimitReached="isLimitReached"
        :value="value"
        :poll="poll"
      />
      <div
        class="d-flex justify-content-center align-items-end text-size-22 "
        style="height: 32px;"
        :style="style"
        v-if="value === -2"
      >
        <div v-if="isLimitReached" class="limit-reached text-size-12">
          {{ $t('choiceDialog.notAvailable') }}
        </div>
        <font-awesome-icon v-else :icon="['fas', 'question']" />
      </div>

      <div
        style="height: 32px;"
        class="d-flex justify-content-center align-items-end text-size-22"
        v-if="value === 0"
      >
        <div v-if="isLimitReached" class="limit-reached text-size-12">
          {{ $t('choiceDialog.notAvailable') }}
        </div>
        <div v-else :style="style">
          <font-awesome-icon :class="cssDisabled" :icon="['fas', 'times']" />
        </div>
      </div>
      
      <div v-if="value > 0" :style="style" 
        :class="checkedCss"
        class="k-checked d-flex align-items-center mt-2">
        <span v-if="value === 2">(</span>
        <font-awesome-icon :icon="['fas', 'check']" />
        <span v-if="value === 2">)</span>
      </div>

      <!-- <div v-if="(isCurrentUser && value >=0 && 0 )" class="current-user-notification">
      &zwnj;
    </div> -->
    </div>

    <!-- <div class="test"></div>
      {{ preference.answers }}     -->
    <RenderCustomAnswers
      v-if="showAnswers"
      :value="value"
      :preference="preference"
      :isCentered="!isMobile"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { answerMixin } from '../mixins/AnswerMixins.js';
import { gridMixin } from '../mixins/GridMixins';
import RenderNameOfQuestion from './RenderNameOfQuestion';
import RenderCustomAnswers from './RenderCustomAnswers';

//const isEmpty = (str) => (!str?.length);

export default {
  name: 'RenderPreference',
  mixins: [answerMixin, gridMixin],

  props: {
    value: {
      type: Number,
      required: true,
    },

    preference: {
      type: Object,
      default: null,
    },

    isEditable: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isCurrentUser: {
      type: Boolean,
      default: false,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
    submitMode: {
      type: Boolean,
      default: false,
    },
    isDesktopMode: {
      type: Boolean,
      default: true,
    },
    isLimitReached: {
      type: Boolean,
      default: false,
    },

    showAnswers: {
      type: Boolean,
      default: true,
    },

    showNameOfQuestion: {
      type: Boolean,
      default: false,
    },

    isMobile : {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },

  components: {
    RenderCustomAnswers,
    RenderNameOfQuestion,
  },

  methods: {
    isActiveAnswer(index) {
      const choice_config = this.poll.choice_config;
      if (!choice_config) return 0;
      const active = choice_config.additional_answers[index].active;
      return active;
    },

    toggleChoice() {
      if (this.isDisabled || !this.showEditButton) return;
      // this.$emit('toggle', event);
      let currentUserChoices = this.value;
      switch (currentUserChoices) {
        case (2, -2):
          currentUserChoices = -2;
          break;

        default:
          currentUserChoices++;
          break;
      }
      console.log('toggleChoice new value:', this.value, currentUserChoices);
      this.$emit('toggle', {
        newValue: currentUserChoices,
        originalValue: this.value,
      });
    },
  },
  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),


    ...mapGetters(['isDeadlinePassed']),

    checkedCss() {
      if( this.showEditButton || !this.isMobile ) {
        return "justify-content-center"
      }
        return "justify-content-end"

    },
    aligmentCss() {
      if( this.isMobile ) {
        return 'justify-content-start';
      }
      return 'justify-content-center';
    },

    choiceDataHeight() {
      return 'height:100px';
    },

    answerText() {
      if (this.isDisabled) {
        return this.$t('choiceDialog.notAvailable');
      }
      return this.pleaseAnswer;
    },

    cssAnswerText() {
      if (this.isDisabled) {
        return null;
      }
      return this.cssProvideAnswer;
    },

    mobileView() {
      return this.$store.state.mobileView;
    },
    cssDisabled() {
      if (this.isDisabled) return 'k-disabled';
      return '';
    },

    style() {
      // if (this.isCurrentUser) {
      //   return 'height: 52px;padding-top: 12px';
      // }
      if (this.loading == 1) {
        return 'height: 46px';
      }
      return '';
    },
    getColor() {
      return this.poll.options.darkMode == true ? 'white' : '#1d1d1d';
    },
  },
  filters: {},
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

.k-disabled {
  color: $light-grey;
  cursor: default !important;
}

.k-choice-value {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: 2px;
  padding-top: 4px;
  padding-bottom: 4px;
  //flex-basis: 90px;
  width:100%;
  font-size: 24px;
  text-align: center;
  height: 95%;
}

.k-choice-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-basis: 60px;
}

// @media (min-width: 640px) {
//   .k-choice-value {
//     font-size: 20px;
//   }
// }

.editable {
  cursor: pointer;
}

.k-no-answer {
  display: inline;
}
.current-user-notification-parent {
  border-bottom: unset;
  padding: 6px !important;
  // display: block !important;
  border-top: 2px solid !important;
  border-bottom: 3px solid !important;
  border-right: unset;
  border-left: unset;
}
.current-user-notification {
  font-size: $very-small;
  font-weight: $medium-weight;
}
.k-choice-details:last-child {
  .current-user-notification-parent:first-child {
    border-right: 0px solid !important;
  }
}

.k-choice-value.current-user-notification-parent:first-child {
  border-right: unset !important;
  border-left: unset !important;
}

.loading-field {
  padding: 4px;
  border-radius: 3px;
}

.icon-border {
  border: 1px solid #51515d;
  padding: 1px;
  border-radius: 5px;
  // width: 60%;
}

.empty-cell {
  height: 30px;
}

.fixed-height {
  min-height: 65px;
}

.choice-time-value {
  width: 100px;
  text-align: left;
  padding-left: 5px;
}

.choice-data {
  display: flex;
  flex-direction: column;
}

::v-deep .empty-cell-value {
  button {
    padding: 0;
  }
  .text-weight-semi-bold {
    margin-right: 0px !important;
  }
}
</style>
